import React, { useState } from "react";

/** Nextjs */
import dynamic from "next/dynamic";

/** MUI */
import { makeStyles } from "@mui/styles";
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import { ExpandMore, ExpandLess } from "@mui/icons-material";

/** Helpers */
import clsx from "clsx";
import useHelper from "../../../_common/useHelper";

/** UI */
const AppTooltip = dynamic(() => import("../../../_common/AppTooltip"));

const useStyles = makeStyles((theme) => ({
    root: {
        // marginBottom: theme.spacing(4),
    },
    AccordionRoot: {
        borderBottom: "1px solid #0000000D",
        "&:before": {
            opacity: 0,
        },
        // paddingBottom: '11px',//theme.spacing(1.5),
        padding: "18px 0 11px 0",
        "&:not(:first-child)": {
            padding: "18px 0 11px 0", // theme.spacing(3, 0, 1.5, 0),
        },
        "&.Mui-expanded": {
            margin: 0,
        },
    },
    AccordionRootExpanded: {},
    title: {
        fontWeight: 600,
        color: "#000",
        paddingBottom: theme.spacing(2),
        paddingTop: theme.spacing(0.5),
        [theme.breakpoints.down("xl")]: {
            fontSize: "1rem",
        },
        [theme.breakpoints.down("lg")]: {
            fontSize: "0.88888889rem",
            paddingBottom: theme.spacing(1),
            paddingTop: theme.spacing(0),
        },
    },
    constent: {
        [theme.breakpoints.down("lg")]: {
            fontSize: "0.88888889rem",
            '& ul, & ol':{
                margin: theme.spacing(0,0),
                paddingLeft: theme.spacing(4)
            }
        },
        [theme.breakpoints.down("sm")]: {
            fontSize: "0.77777778rem",
            '& ul, & ol':{
                margin: theme.spacing(0,0),
                paddingLeft: theme.spacing(3)
            }
        },
    },
    colorDB: {
        color: theme.palette.primary.main,
    },
    colorAREA: {
        color: theme.palette.secondary.main,
    },
    colorOTHER: {
        color: "rgba(0,0,0,0.87)", //"#000",
        // fontSize: "1.1111111rem",
        // fontSize: "inherit",

        // paddingBottom: theme.spacing(2),
        // paddingTop: theme.spacing(0.5),
    },
    AccordionSummaryRoot: {
        "&, &.Mui-expanded": {
            minHeight: 48,
        },
        [theme.breakpoints.down("lg")]: {
            alignItems: "flex-start",
        },
    },
    AccordionSummaryContent: {
        "&, &.Mui-expanded": {
            margin: 0,
        },
    },
    AccordionSummaryExpanded: {
        minHeight: 48,
        margin: 0,
    },
    expandIconWrapper: {
        "&.Mui-expanded": {
            opacity: 1,
            transform: "rotate(180deg) translateY(25%)",
            [theme.breakpoints.down("lg")]: {
                transform: "rotate(180deg) translateY(45%)",
            },
        },
    },
    AccordionDetailsRoot: {
        [theme.breakpoints.down("md")]: {
            padding: theme.spacing(0, 1),
        },
    },
}));

const HelpAccordion = (props) => {
    const { items, type, tip, label } = props;

    const classes = useStyles();
    const { translationFromJson } = useHelper();

    /** States */
    const [EXPANDED, setEXPANDED] = useState(false);

    /** Handlers */
    const handleChange = (panel) => (event, isExpanded) => {
        setEXPANDED(isExpanded ? panel : false);
    };

    return (
        <div className={classes.root}>
            {!!items.length &&
                items.map((item) => {
                    return (
                        <Accordion
                            key={item.id}
                            expanded={EXPANDED === item.id}
                            onChange={handleChange(item.id)}
                            elevation={0}
                            classes={{ root: classes.AccordionRoot, expanded: classes.AccordionRootExpanded }}
                        >
                            <AccordionSummary
                                expandIcon={
                                    <AppTooltip
                                        title={EXPANDED === item.id ? tip.close : tip.open}
                                        arrow
                                        placement={"top"}
                                        type={"dark"}
                                        classes={{ tooltip: classes.tooltip }}
                                    >
                                        <ExpandMore
                                            sx={{ color: "rgba(0, 0, 0, 0.87)" }}
                                            aria-label={EXPANDED === item.id ? label.close : label.open}
                                        />
                                    </AppTooltip>
                                }
                                aria-controls={`${item.id}-content"`}
                                id={`${item.id}-header"`}
                                sx={{ p: 0 }}
                                classes={{
                                    root: classes.AccordionSummaryRoot,
                                    content: classes.AccordionSummaryContent,
                                    expanded: classes.AccordionSummaryExpanded,
                                    expandIconWrapper: classes.expandIconWrapper,
                                }}
                            >
                                <Typography className={clsx(classes.title, classes[`color${type.toUpperCase()}`])} component={'h3'}>
                                    {translationFromJson(item, "title")}
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails className={classes.AccordionDetailsRoot}>
                                <div
                                    className={clsx(classes.constent, classes[`color${type.toUpperCase()}`])}
                                    dangerouslySetInnerHTML={{
                                        __html: translationFromJson(item, "content"),
                                    }}
                                />
                            </AccordionDetails>
                        </Accordion>
                    );
                })}
        </div>
    );
};

export default HelpAccordion;
